import script from "./vision.vue?vue&type=script&setup=true&lang=js"
export * from "./vision.vue?vue&type=script&setup=true&lang=js"

import "./vision.vue?vue&type=style&index=0&id=41cb3b70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41cb3b70"]])

export default __exports__